/*
 * HTTP operations for accessing the VP User API.
 * The base URL (`userApiUrl`) is injected per environment at build/deploy time,
 * in the same manner as `baseUrl` in `cloud-backend-infrastructure.js`.
*/

import { getLogger } from '../common/logger';
import { signInRedirect, getAuthenticatedUser } from '../component/oidc/usermanager/oidc-client-usermanager';
import { checkStatus, httpStatusCodes } from './http-common';

const logger = getLogger('user-api-backend');

const DEFAULT_GET_OPTIONS = {
  method: 'GET',
  headers: {},
};

/**
 * Performs a fetch() call to the VP User API, reusing the same OIDC access token
 * that is used for calls to the case management API.
 *
 * @param path - The API path, must start with a slash.
 * @param options - The Fetch options object.
 */
const doFetch = async (path, options) => {
  const url = `${userApiUrl}${path}`;

  logger.debug('Performing', options.method, url);
  const user = await getAuthenticatedUser();
  const headers = { ...options.headers };
  if (user) {
    logger.debug('Adding Authorization header for access token');
    headers.Authorization = `Bearer ${user.access_token}`;
  }
  const response = await fetch(url, { ...options, headers });
  if (response.status === httpStatusCodes.unauthorized) {
    signInRedirect();
  }
  return checkStatus(response);
};

/**
 * Performs a GET request to the given path, and returns the deserialized JSON.
 *
 * @param path
 * @param options
 */
export const getJson = async (path, options = {}) => {
  const response = await doFetch(path, { ...DEFAULT_GET_OPTIONS, ...options });
  return response.json();
};
